export function formatDate(isoString: string): string {
    const date = new Date(isoString);
    const now = new Date();

    const dateStr = date.toLocaleDateString('ru-RU');
    const nowStr = now.toLocaleDateString('ru-RU');

    const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const yesterdayStr = yesterday.toLocaleDateString('ru-RU');

    if (dateStr === nowStr) {
        return `Сегодня ${time}`;
    } else if (dateStr === yesterdayStr) {
        return `Вчера ${time}`;
    } else {
        return dateStr + ` ${time}`;
    }
}
